function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.5166,
  cy: 21.0886,
  r: 20.75,
  fill: "#B8C52C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7575 17.2593V25.7501H15.5292V21.9459H10.7711V25.7501H9.55469V17.2593H10.7711V20.9323H15.5292V17.2593H16.7575Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5409 25.7501H24.241L23.1797 22.9238C23.0684 22.6217 22.9054 22.415 22.6907 22.3037C22.4761 22.1844 22.1819 22.1248 21.8083 22.1248H19.9479V25.7501H18.7315V17.2593H22.2257C23.1558 17.2593 23.8674 17.466 24.3603 17.8794C24.8611 18.2928 25.1116 18.8851 25.1116 19.6563C25.1116 20.2128 24.9645 20.6858 24.6703 21.0754C24.3762 21.4649 23.9588 21.7392 23.4182 21.8982C23.9111 21.9857 24.2688 22.3355 24.4915 22.9476L25.5409 25.7501ZM22.0825 21.135C22.7027 21.135 23.1638 21.0157 23.4659 20.7772C23.768 20.5308 23.919 20.1651 23.919 19.6801C23.919 19.1951 23.768 18.8374 23.4659 18.6068C23.1717 18.3683 22.7106 18.2491 22.0825 18.2491H19.9479V21.135H22.0825Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5461 23.6512H28.253L27.3467 25.7501H26.0946L29.8749 17.2593H30.9124L34.7046 25.7501H33.4524L32.5461 23.6512ZM32.1287 22.6733L30.3996 18.6307L28.6704 22.6733H32.1287Z",
  fill: "white"
});

var SvgHra = function SvgHra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hra.707c7c62.svg";
export { ForwardRef as ReactComponent };